import React                          from 'react';
import PropTypes                      from 'prop-types'

import MobilePriceMatrixRow           from './MobilePriceMatrixRow';

const MobilePriceMatrixBody = props => {
  return (
    <tbody>
      {props.quantities.map((qty, row) => (
        <MobilePriceMatrixRow
          hiddenRow = {(props.rowSelected !== undefined && props.showSummary && props.rowSelected !== row)}
          key={row}
          quantity={qty}
          row={row}
          {...props} />
      ))}
    </tbody>
  );
}

MobilePriceMatrixBody.propTypes = {
  quantities: PropTypes.array.isRequired,
  showSummary: PropTypes.bool.isRequired,
  rowSelected: PropTypes.number,
};

export default MobilePriceMatrixBody;